/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteIntegrationModal_integration$ref: FragmentReference;
declare export opaque type DeleteIntegrationModal_integration$fragmentType: DeleteIntegrationModal_integration$ref;
export type DeleteIntegrationModal_integration = {|
  +id: string,
  +source: {|
    +id: string,
    +name: string,
  |},
  +$refType: DeleteIntegrationModal_integration$ref,
|};
export type DeleteIntegrationModal_integration$data = DeleteIntegrationModal_integration;
export type DeleteIntegrationModal_integration$key = {
  +$data?: DeleteIntegrationModal_integration$data,
  +$fragmentRefs: DeleteIntegrationModal_integration$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DeleteIntegrationModal_integration",
  "type": "Integration",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "source",
      "storageKey": null,
      "args": null,
      "concreteType": "IntegrationSource",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '94b88919956436408bbb0ba45cd10036';
module.exports = node;
